export default __webpack_public_path__ + "static/media/triangle-down.cb360e39.svg";